import { render, staticRenderFns } from "./AllExamineDetail.vue?vue&type=template&id=70c88b58&scoped=true&"
import script from "./AllExamineDetail.vue?vue&type=script&lang=js&"
export * from "./AllExamineDetail.vue?vue&type=script&lang=js&"
import style0 from "./AllExamineDetail.vue?vue&type=style&index=0&id=70c88b58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c88b58",
  null
  
)

export default component.exports